import * as React from 'react'

import {
  Box,
  Popover
} from '@mui/material';

import { SketchPicker } from 'react-color';

function hexToRGBA(hex) {
  if(!hex || typeof hex !== 'string') {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 1,
    }
  }
  // Expand shorthand form (e.g. "#03F") to full form (e.g. "#0033FF")
  let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
      return r + r + g + g + b + b;
  });

  let regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
  let result = regex.exec(hex);
  if (!result) {
      throw new Error("Invalid hex color code");
  }

  let r = parseInt(result[1], 16);
  let g = parseInt(result[2], 16);
  let b = parseInt(result[3], 16);
  let a = 1; // Assuming alpha as 1 by default

  return {
      r: r,
      g: g,
      b: b,
      a: a
  };
}

function rgbToHex(r, g, b) {
  // Ensure the values are within the valid range of 0 to 255
  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));
  
  // Convert each value to a 2-digit hexadecimal string
  const toHex = (value) => value.toString(16).padStart(2, '0');
  
  // Concatenate the strings and prepend with #
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
}


export default function ColorItem(props) {
  const {color: defaultColor, id, onChange} = props;

  const rgbaColor = defaultColor === undefined ? "" : hexToRGBA(defaultColor);

  const [color, setColor] = React.useState(rgbaColor);
  const [anchorEl, setAnchorEl] = React.useState(null);
  
  const open = Boolean(anchorEl);
  const colorId = open ? `color-picker-${id}` : undefined;
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColor = (color) => {
    setColor(color.rgb);
    let {r,g,b} = color.rgb
    const newColor = rgbToHex(r, g, b);

    onChange(id, newColor);
  }

  let { r, g, b, a} = color;
  const hexColor = rgbToHex(r, g, b);

  return (
    <Box className="w-full">
      <Box className="w-full border-gray border-box padding-4" aria-describedby={colorId} onClick={handleClick} sx={{cursor: 'pointer'}}>
        {
          color !== "" ? (<Box className="flex align-center color-panel-gap">
            <Box className="border-gray color-panel" sx={{backgroundColor: `rgba(${r},${g},${b},${a})`}}/>
            <Box className="font-sm text-center" sx={{flexGrow: 3}}>
              {hexColor}
            </Box>
          </Box>) : (<Box className="flex align-center color-panel-gap">
            <Box className="border-gray color-panel"/>
            <Box className="font-sm text-center" sx={{flexGrow: 3}}>
              +Add
            </Box>
          </Box>)
        }
      </Box>
      <Popover
        id={colorId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <SketchPicker 
          onChange={handleColor}
          color={color}
        />
      </Popover>
    </Box>
  )
}